export { default } from './ProductCoupon';